import type { IconType } from "@circle-react-shared/Icon";
import { TextModifierIcon } from "@circle-react-shared/uikit/TipTap/Extensions/TextModifiers/TextModifierButton/TextModifierIcon";
import classNames from "classnames";

interface AlignmentButtonProps {
  disabled?: boolean;
  iconType: IconType;
  isActive?: boolean;
  label?: string;
  onClick: () => void;
}

export const AlignmentButton = ({
  isActive = false,
  disabled = false,
  onClick,
  iconType,
  label,
}: AlignmentButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={label}
    className={classNames(
      "text-feature-dark bg-text-editor-modifier hover:bg-text-editor-modifier-hover rounded-sm p-1 disabled:pointer-events-none disabled:opacity-40",
      { "bg-text-editor-modifier-active": isActive },
    )}
  >
    <TextModifierIcon type={iconType} iconSize={16} />
  </button>
);
